import type * as t from "~/types";

import { getContext as _getContext, setContext } from "svelte";
import { writable } from "svelte/store";
import { getAppContext } from "~/quiz-store";

type MultipleChoiceStepStore<T> = {
    selectedOption: t.MultipleChoiceOption | undefined;
} & T;

export function createContext(step: t.MultipleChoiceStep) {
    const { telemetry } = getAppContext();
    const hookCallbacks: {
        onSelectOption: ((option: t.MultipleChoiceOption) => void) | undefined;
    } = {
        onSelectOption: undefined,
    };

    function selectOption(option: t.MultipleChoiceOption) {
        telemetry.logEvent("option_selected", {
            question: step.title,
            answer: option.title,
        });

        const onSelectOption = hookCallbacks.onSelectOption;
        if (onSelectOption != null) {
            onSelectOption(option);
        }

        ctx.update(($) => {
            $.selectedOption = option;
            return $;
        });
    }

    function onSelectOption(
        fn: (selectedOption: t.MultipleChoiceOption) => void,
    ) {
        hookCallbacks.onSelectOption = fn;
    }

    const actions = { selectOption };
    const hooks = { onSelectOption };
    const ctx = writable<
        MultipleChoiceStepStore<typeof actions & typeof hooks>
    >({
        selectOption,
        onSelectOption,
        selectedOption: undefined,
    });

    setContext("multiple_choice_step", ctx);

    return ctx;
}

export function getContext() {
    return _getContext<ReturnType<typeof createContext>>(
        "multiple_choice_step",
    );
}
